import Swiper from 'swiper';
import { whenElementReady } from '../../../../application/typescript/utils/utils';

class PushRessources {
  constructor() {
    this._init();
  }

  _init() {
    whenElementReady('.push-ressources__swiper', () => {
      new Swiper('.push-ressources__swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 20,
        grabCursor: true,
        mousewheel: true,
        preventInteractionOnTransition: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 32
          }
        }
      });
    });
  }
}

export const pushRessources = new PushRessources();
